import { render, staticRenderFns } from "./RewriteTextDialog.vue?vue&type=template&id=6c6b7ba4"
import script from "./RewriteTextDialog.js?vue&type=script&lang=js&external"
export * from "./RewriteTextDialog.js?vue&type=script&lang=js&external"
import style0 from "./RewriteTextDialog.vue?vue&type=style&index=0&id=6c6b7ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports